import Controller from '@ember/controller';

export default class SsoConfirmEmailController extends Controller {}
